import { List } from "@mui/material"
import { useEffect, useState } from "react"
import { useNotify, useRecordContext } from "react-admin"
import { InvoiceReadModel, InvoiceReminderReadModel, ReverseInvoiceReadModel } from "../GeneratedClients/FreeBillApi"
import { apiService } from "../apiService"
import InvoiceCorrelationListItem from "./InvoiceCorrelationListItem"

const InvoiceChildrenList = () => {
  const notify = useNotify()
  const record = useRecordContext<InvoiceReadModel>()
  const [reverseInvoice, setReverseInvoice] = useState<ReverseInvoiceReadModel>()
  const [invoiceReminders, setInvoiceReminders] = useState<InvoiceReminderReadModel[]>()
  
  const getReverseInvoice = async(id: string) => {
    try {
      var {data:reverseInvoice} = await apiService.ReverseInvoicesApi.getReverseInvoiceByCanceledInvoiceId({canceledInvoiceId: id})
      setReverseInvoice(reverseInvoice)  

    } catch (error) {
      notify(`${error}`, {type:'error'})
    }
  }

  const getInvoiceReminders = async(id: string) => {
    try {
      var {data:invoiceReminders} = await apiService.InvoiceRemindersApi.getInvoiceRemindersByInvoiceId({invoiceId: id})
      setInvoiceReminders(invoiceReminders)
    } catch (error) {
      notify(`${error}`, {type:'error'})
    }
  }

  useEffect(() => {
    if(record.id && record.isCanceled) getReverseInvoice(record.id)
    if(record.id && record.reminderStepNumber !== null) getInvoiceReminders(record.id)
  }, [])

  if(!record) return null

  return (
    <List dense={true} sx={{p:0}}>
      {
        reverseInvoice && <InvoiceCorrelationListItem record={reverseInvoice} resource="reverseInvoices" />
      }
      {
        invoiceReminders && invoiceReminders.map(invoiceReminder => 
          <InvoiceCorrelationListItem record={invoiceReminder} resource="invoiceReminders" />
        )
      }
    </List>
  
  )
}

export default InvoiceChildrenList